import { EngagementBuyer } from './engagement-buyer.model';
import { EngagementBroker } from './engagement-broker.model';
import { EngagementPractice } from './engagement-practice';
import { EngagementSuspension } from './engagement-suspension';
import { EngagementProcessStatus } from './enums/engagement-process-status.enum';
import { EngagementBuyerVisibilityState } from './engagement-buyer-visibility-state.model';
import { EngagementObserver } from './engagement-observer.model';

export interface EngagementProcess {
    id: number;
    practices: EngagementPractice[];
    userId: number;
    userName: string;
    status: EngagementProcessStatus;
    startDate: Date;
    deadline: Date;
    closingDate?: string | null;
    timelineId: number;
    buyers?: EngagementBuyer[];
    buyerVisibilityStates? : EngagementBuyerVisibilityState[];
    engagementSuspensions: EngagementSuspension[];
    terminationDate?: Date;
    broker?: EngagementBroker;
    observers?: EngagementObserver[];
    isBrokerReviewEnabled?: boolean;
    sellerProfileId: string;
    isBuyerChatsEnabled: boolean;
    useCreditsForMonthlyFees: boolean;
    isWalletCreditsForMonthlyFeesAllowed: boolean;
    isSellerDaqiEditableDuringSuspension?: boolean;
    startFteDvm: number;
    startLtmRevenue: number;
    monthlyEngagementFee?: number;
    ltmRevenueThresholdPercent?: number;
    feePercentOnTotalFairValue?: number;
    feePercentOnExcessFairValue?: number;
    isFeeDetailsVisible?: boolean;
    sfasTotalRetainerFee?: number;
    advisorCompanyId?: string;
}

export const anyLoiSelected = (
    engagementProcess: EngagementProcess | null | undefined,
): boolean => engagementProcess?.buyers?.some((b) => b.isLoiSelected) ?? false;
